import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { OutletModule, OutletRefModule, PageLayoutModule, PageSlotModule, KeyboardFocusModule, SkipLinkModule } from "@spartacus/storefront";
import { CustomStorefrontComponent } from "./custom-storefront.component";
import { CustomGlobalMessageComponentModule } from "../../cms-components/misc/global-message/custom-global-message.module";
import { provideConfig } from "@spartacus/core";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CustomGlobalMessageComponentModule,
    OutletModule,
    OutletRefModule,
    PageLayoutModule,
    PageSlotModule,
    KeyboardFocusModule,
    SkipLinkModule,
  ],
  declarations: [CustomStorefrontComponent],
  exports: [CustomStorefrontComponent],
  providers: [
    provideConfig({
      cmsComponents: {
        StorefrontComponent: {
          component: CustomStorefrontComponent,
        },
      },
    }),
  ]
})
export class CustomStorefrontComponentModule {}
